<template>
  <div>
    <div v-for="(time, timeKey) in times"
         :key="timeKey"
         :class="'prescription-block ' + (time.methods.length === 0 ? 'inactive' : '')">
      <div
        class="prescription-list"
        v-for="(method, methodKey) in time.methods"
        :key="methodKey">
        <div class="prescription-title">
          <div class="prescription-title-time">{{ time.name }}</div>
          <div class="prescription-title-method">{{ method.name }}</div>
        </div>

        <div class="prescription-items">
          <ScheduleItem
            v-for="(item, itemKey) in method.items"
            :key="itemKey"
            :item="item"
            :date="date" />
        </div>
      </div>

      <div v-if="time.methods.length === 0">
        <div class="prescription-title inactive">
          <div class="prescription-title-time">{{ time.name }}</div>
          <div class="prescription-title-method">Назначений на это время нет</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import ScheduleItem from './Item';

  export default {
    name: 'Schedule',

    components: {ScheduleItem},

    props: ['prescriptions', 'date'],

    data() {
      return {};
    },

    computed: {
      times() {
        const times = this.$store.state.times.map(({id, name, sort}) => {
          return {id, name, sort, methods: []};
        });

        this.prescriptions.forEach(prescription => {
          prescription.times.forEach(prescriptionTime => {
            const time = times.find(time => time.id === prescriptionTime.id);

            if (!time) {
              return;
            }

            prescription.methods.forEach(prescriptionMethod => {
              const method = time.methods.find(
                method => method.id === prescriptionMethod.id
              );

              if (method) {
                return method.items.push(prescription);
              }

              time.methods.push({
                id: prescriptionMethod.id,
                name: prescriptionMethod.name,
                sort: prescriptionMethod.sort,
                items: [prescription],
              });
            });
          });
        });

        times.sort((a, b) => a.sort - b.sort);
        times.forEach(time => time.methods.sort((a, b) => a.sort - b.sort));

        return times;
      }
    },

    methods: {},
  }
</script>

<style lang="scss">
  @import "../../assets/scss/variables.scss";

  .prescription-block {
    .prescription-title {
      position: relative;
      padding: 10px 0 10px 95px;
      font-size: 12px;
      font-weight: bold;
      text-transform: uppercase;
      color: $primary;
      border-top: 2px solid $primary;
      border-bottom: 2px solid $primary;

      .prescription-title-time {
        position: absolute;
        left: 0;
        top: 0;
        width: 80px;
        height: 100%;
        padding-top: 10px;
        text-align: center;
        color: $white;
        background-color: $primary;
      }

      &.inactive {
        opacity: 0.3;
      }
    }
  }
</style>
